import React from "react";
import * as CHQ from "chq";

import { ProfileLink, RecognitionLink } from "app/links";
import { t, Trans } from "app/utils";

import NotificationBody from "./NotificationBody";

type RecognitionReceivedCheeredNotificationProps = {
  notification: CHQ.NotificationRecognitionReceivedCheered;
  tabIndex?: number;
};

const RecognitionReceivedCheeredNotification: React.FC<
 RecognitionReceivedCheeredNotificationProps
> = ({ notification: { actor, entity }, tabIndex }) => {
  const { creator } = entity.cheerable;

  return (
    <NotificationBody actor={actor}>
      <ProfileLink user={actor} tabIndex={tabIndex || 0} />
      {" "}
      <Trans>
        cheered the
        {" "}
        <RecognitionLink recognition={entity.cheerable} tabIndex={tabIndex || 0}>
          recognition
        </RecognitionLink>
        {" "}
        you received from
      </Trans>
      {" "}
      {creator ? <ProfileLink user={creator} tabIndex={tabIndex || 0} /> : t("CultureBot")}
    </NotificationBody>
  );
};

export default RecognitionReceivedCheeredNotification;
